import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';

interface EmptyStateProps {
  onResetFilters: () => void;
}

export const EmptyState = ({ onResetFilters }: EmptyStateProps) => {
  const { t } = useTranslation('drivers');
  return (
    <div className='flex min-h-[400px] flex-col items-center justify-center gap-3 text-center'>
      <Icon name='scan-face' size='lg' color='gray' />
      <Typography variant='text-md-semibold'>{t('face_id.selector.empty.title')}</Typography>
      <Typography variant='text-md' color='secondary'>
        {t('face_id.selector.empty.hint')}
      </Typography>
      <Button type='button' variant='outlined' size='sm' onClick={onResetFilters}>
        {t('face_id.selector.empty.reset')}
      </Button>
    </div>
  );
};
